import type { YearSummary } from '../../../entities/summary/index.js';

const hasConversionAtTodaysRate = (summary: YearSummary): boolean =>
  summary.payments.some((payment) => payment.isConverted);

export const isSpendingApproximate = (summary: YearSummary): boolean => {
  const hasConvertedOperations = (summary.bank?.convertedOperationCount ?? 0) > 0;

  return (
    summary.spending.hasEstimates || hasConversionAtTodaysRate(summary) || hasConvertedOperations
  );
};

export const isSpentApproximate = (summary: YearSummary): boolean =>
  (summary.bank?.convertedOperationCount ?? 0) > 0;

export const isPlannedApproximate = (summary: YearSummary): boolean =>
  summary.spending.hasEstimates || hasConversionAtTodaysRate(summary);

export const isSubscriptionsApproximate = (summary: YearSummary): boolean => {
  const hasEstimatedSubscriptions = summary.subscriptions.estimatedMinor > 0;
  const hasConvertedCharges = summary.subscriptions.isConverted;

  return hasEstimatedSubscriptions || hasConversionAtTodaysRate(summary) || hasConvertedCharges;
};
